<template>
	<div>
		<!-- 腾讯视频领取说明 -->
		<div class="qqInfo" v-if="qqInfo === 2">
			<img src="https://img.ykplg.com/eticket/20200525/qqten1.png" alt="">
			<img src="https://img.ykplg.com/eticket/20200525/qqten2.png" alt="">
		</div>
		<!-- 腾讯视频详情参考说明 -->
		<div class="qqInfo" v-if="qqInfo === 1">
			<img src="https://img.ykplg.com/eticket/20200525/91c45c1b48da417b952208930246f64e.jpg" alt="">
			<img src="https://img.ykplg.com/eticket/20200525/c24400085f224f1a80d9d013b8de9014.jpg" alt="">
		</div>
		<div class="wrapper" v-if="qqInfo === 0">
			<div class="use" v-if="status===0">
				<div class="head_tip">客服热线 0571-85199986(服务时间8:30-20:00)</div>
				<div class="head">
					<header>
						<div class="lt">
							<p>{{typeName}}</p>
							<span>链接有效期至:{{expiredDate}}</span>
						</div>
						<img :src="src" alt="视频会员充值">
						<span class="ico">电子券</span>
					</header>
				</div>
				<div class="body">
					<header>
						您已选择充值【{{txt}}】，本产品为虚拟产品，请务必核对账户正确，充值后不可撤销且无法退返，直充券码：充值结果请至品牌运营商后台核查，线下商户：请按照券码使用规则使用。
					</header>
					<div class="bd" v-if="ChangeAccountType==0">
						<h1>充值账号</h1>
						<div class="txt"><span>账号</span><input type="number" placeholder="请输入充值手机号" v-model="accountNo"></div>
						<div class="form">
							<div class="code">
								<span>验证码</span>
								<input type="text" placeholder="请输入验证码" v-model="verifyCode">
							</div>
							<button v-if="verifyShow" @click="verifyCodeGet(accountNo)">获取验证码</button>
							<em v-if="!verifyShow">{{verifyTime}}s</em>
						</div>
					</div>
					<div class="bd" v-if="ChangeAccountType==1">
						<h1>充值账号(QQ账号<span v-if="ChangeAccountType==1 && productId!=11">或手机号</span>)</h1>
						<div style="color: #F76A24;" v-if="ChangeAccountType==1 && productId!=11">
							<p>手机号充值仅限用手机号登陆过腾讯视频的用户，且您的手机号已经和QQ账号或微信账号关联。<a href="javascript:void(0);" @click="toQQInfo(1)">详情参考图示</a></p>
						</div>
						<div class="txt"><span>账号</span><input type="number" placeholder="请输入QQ账号或手机号" v-model="accountNo"></div>
						<div class="txt"><span>再次输入</span><input type="number" placeholder="请再次输入QQ账号或手机号" v-model="reAccountNo"></div>
					</div>
					<div class="ft" v-if="ChangeAccountType==1 && productId!=11">
						<p>若您未用手机号绑定用户，充值成功了，但是领取不到已充值的权益，请按如下操作：<a href="javascript:void(0);" @click="toQQInfo(2)">权益领取图示</a>，若上述操作后权益还未到账，我司无法退款，请致电腾讯视频官方客服解决。</p>
					</div>
					<!-- <div class="ft">
                    <p>温馨提示: 本产品为虚拟产品,兑换前请务必核对充值账户的正确性。为了保证您的利益，充值需通过短信验证，券码充值成功后无法退返，请至品牌运营商后台核查到账情况。客服热线:0571-85199986</p>
                </div> -->
				</div>
				<div class="foot">
					<button @click="submit" :disabled="disabled" v-if="ChangeAccountType==0">{{submitTxt}}</button>
					<button @click="submitTX" :disabled="disabled" v-if="ChangeAccountType==1">{{submitTxt}}</button>
				</div>
			</div>
			<div class="use" v-if="status===1 || status===3">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{txt}}</p>
							<span>有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd1">
					<div class="ft" v-if="ChangeAccountType==1 && productId!=11">
						<p>若您未用手机号绑定用户，充值成功了，但是领取不到已充值的权益，请按如下操作：<a href="javascript:void(0);" @click="toQQInfo(2)">权益领取图示</a>，若上述操作后权益还未到账，我司无法退款，请致电腾讯视频官方客服解决。</p>
					</div>
				</div>
				<div class="bd1">
					<div class="nodata">
						<img src="../assets/used.png" alt="电子券已使用">
						<p>电子券已使用</p>
					</div>
				</div>
			</div>
			<div class="use" v-if="status===4">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{txt}}</p>
							<span>有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd1">
					<div class="nodata">
						<img src="../assets/outDate.png" alt="电子券已失效">
						<p>电子券已失效</p>
					</div>
				</div>
			</div>
			<div class="result" v-if="flag">
				<div class="dec">
					<img :src="srcDec" alt="成功">
					<p>{{dec}}</p>
				</div>
			</div>
			<div class="pop" v-if="popVisible">
				<div class="win">
					<div class="box">
						<h1>手机号验证</h1>
						<div class="txt" v-if="mobile==''"><span>手机号</span><input type="number" placeholder="输入手机号" v-model="qqAccount"></div>
						<div class="txt" v-if="mobile!=''" style="margin-bottom:40px"><span>手机号</span><input type="number" placeholder="输入手机号"
							 v-model="qqAccount"></div>
						<div class="form" v-if="mobile==''">
							<div class="code">
								<span>验证码</span>
								<input type="text" placeholder="输入验证码" v-model="verifyCode">
							</div>
							<button v-if="verifyShow" @click="verifyCodeGet(qqAccount)">获取验证码</button>
							<em v-if="!verifyShow">{{verifyTime}}s</em>
						</div>
						<button class="submit" @click="submitPhone" v-if="mobile==''">确认</button>
						<button class="submit" @click="submitVerifyPhone" v-if="mobile!=''">确认</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				qqInfo: 0,
				// type:this.$route.query.type,
				typeName: this.$route.query.txt,
				fuluProductIdParam: this.$route.query.fuluProductId,
				src: this.$route.query.logo,
				txt: this.$route.query.txt,
				key: this.$route.query.key,
				expiredDate: this.$route.query.expiredDate,
				mobile: this.$route.query.mobile,
				qqAccount: '',
				ChangeAccountType: this.$route.query.ChangeAccountType,
				productCategoryId: this.$route.query.productCategoryId,
				productId: this.$route.query.productId,
				accountNo: '',
				reAccountNo: '',
				flag: false,
				disabled: false,
				submitTxt: '确认充值',
				dec: '',
				srcDec: require('../assets/success.png'),
				seconds: 5,
				status: 0,
				verifyShow: true,
				visible: true,
				verifyCode: '',
				verifyTime: 60,
				first: true,
				showType: 0,
				popVisible: this.$route.query.ChangeAccountType == 1 ? true : false
			}
		},
		mounted() {
			// this.minus();
			console.log('mobile:', this.mobile)
			document.title = this.typeName;
		},
		methods: {
			toQQInfo(qqInfo) {
				this.qqInfo = qqInfo;
			},
			submitVerifyPhone() {
				if (this.mobile === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						mobile: this.qqAccount,
						ticketNo: this.key
					}
					// this.disabled = true;
					this.$http.POST('productTicket/verifyMobile', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							this.flag = true;
							this.srcDec = require('../assets/success.png');
							this.dec = '验证成功';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.popVisible = false
						} else {
							this.flag = true;
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			verifyCodeGet(mobile) {
				if (this.visible) {
					this.visible = false;
					this.$http.POST('sms/send', {
						accountNumber: mobile,
						type: 1
					}).then((res) => {
						this.flag = true;
						if (res.code === 0) {
							this.dec = '验证码发送成功';
							this.srcDec = require('../assets/success.png');
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.verifyShow = false;
							const timer = setInterval(() => {
								this.verifyTime--;
								if (this.verifyTime <= 0) {
									this.verifyShow = true;
									this.visible = true;
									clearInterval(timer);
									this.verifyTime = 60;
								}
							}, 1000);
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = '验证码发送失败';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			minus() {
				var _this = this;
				_this.submitTxt = '充值中...' + _this.seconds + 's';
				var time = window.setInterval(function() {
					if (_this.seconds === 0) {
						_this.seconds = 5;
						window.clearInterval(time);
						_this.getOrderInfo();
					} else {
						_this.submitTxt = '充值中...' + _this.seconds + 's';
						_this.seconds -= 1
					}
				}, 1000)
			},
			submitPhone() {
				const obj = {
					ticketNo: this.key,
					mobile: this.qqAccount,
					code: this.verifyCode
				}
				this.$http.POST('productTicket/bindMobile', obj).then(res => {
					console.log(res)
					if (res.code == 0) {
						this.popVisible = false;
					} else {
						this.flag = false;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				})
			},
			submit() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '充值账户不能为空！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else if (this.verifyCode === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入验证码！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						accountNumber: this.accountNo,
						ticketNo: this.key,
						productCategoryId: this.productCategoryId,
						code: this.verifyCode
					}
					this.disabled = true;
					this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							this.minus();
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认充值';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}

			},
			submitTX() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入QQ号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.reAccountNo === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请再次输入QQ号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.accountNo !== this.reAccountNo) {
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入相同的QQ号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				} else {
					const obj = {
						// productType:this.type,
						// buyNum:1,
						accountNumber: this.accountNo,
						ticketNo: this.key,
						// fuluProductIdParam:this.fuluProductIdParam
						productCategoryId: this.productCategoryId
					}
					this.disabled = true;
					this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// const customerOrderNo = res.data.customerOrderNo;
							this.minus();
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认充值';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			getOrderInfo() {
				const obj = {
					ticketNo: this.key,
					isVerify: '-1',
					mobile: this.accountNo
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.flag = true;
					this.disabled = false;
					this.submitTxt = '确认充值';
					if (res.code == 0) {
						this.dec = '充值成功';
						this.srcDec = require('../assets/success.png');
						this.status = 1;
					} else {
						if (res.code === 3001) {
							this.dec = '充值成功';
							this.srcDec = require('../assets/success.png');
							this.status = 1;
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
						}
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.qqInfo{
		img{
			max-width:100%;
			padding:5px 0;
		}
	}
	.wrapper {
		font-size: 16px;
		height: 100%;
		position: relative;

		.use {
			height: 100%;
			position: relative;

			.head_tip {
				background: #FEFCEC;
				padding: 10px;
				// line-height: 36px;
				font-size: 14px;
				color: #F76A24;
			}

			.head {
				height: 110px;
				background: #fff;
				padding: 10px 15px 15px 15px;
				box-sizing: border-box;

				header {
					height: 85px;
					background: url('../assets/recharge_bg.png') no-repeat;
					background-size: 345px 85px;
					position: relative;

					span.ico {
						position: absolute;
						bottom: 0;
						left: 0;
						border-bottom-left-radius: 4px;
						border-top-right-radius: 7px;
						font-size: 15px;
						color: #fff;
						padding: 0 4px;
						background: linear-gradient(to right, #FF8E00, #FF5500);
					}

					.lt {
						padding: 10px 0 0 15px;
						float: left;

						p {
							font-size: 17px;
							color: #333333;
							font-weight: bold;
						}

						span {
							font-size: 14px;
							color: #333333;
							padding-top: 2px;
						}
					}

					img {
						float: right;
						width: 60px;
						height: 60px;
						margin: 12.5px 12.5px 12.5px 0;
					}
				}

				header.used {
					background: url('../assets/used_bg.png') no-repeat;
					background-size: 345px 85px;

				}
			}

			.body {
				header {
					// height: 36px;
					background: #FEFCEC;
					padding: 10px;
					// line-height: 36px;
					font-size: 14px;
					color: #F76A24;
				}

				.bd {
					padding: 16px;

					h1 {
						font-size: 18px;
						font-weight: bold;
						color: #333333;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 232px;

							span {
								flex: 1;
							}

							input {
								width: 128px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 96px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #F76A24;
				}
			}

			.bd1 {
				display: flex;
				justify-content: center;
				align-items: center;

				.nodata {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding-top: 50px;

					img {
						width: 100px;
						height: 100px;
					}

					p {
						font-size: 17px;
						color: #555555;
						padding-top: 10px;
					}
				}
				.ft{
				    padding: 4px 16px 0 16px;
				    font-size: 16px;
				    color: #888888;
				}
			}

			.foot {
				// position: absolute;
				// bottom: 0;
				padding: 70px 16px 16px 16px;
				display: flex;
				width: 100%;
				box-sizing: border-box;

				button {
					flex: 1;
					height: 60px;
					line-height: 60px;
					color: #fff;
					background: linear-gradient(to right, #F9AF2F, #F5881A);
					font-size: 17px;
					border-radius: 8px;
				}
			}
		}

		.result {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;

			.dec {
				min-width: 120px;
				height: 120px;
				background: rgba(58, 58, 58, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				border-radius: 2px;
				padding: 0 10px;

				img {
					width: 36px;
					height: 36px;
					font-size: 14px;
				}

				p {
					font-size: 14px;
					color: #fff;
					padding-top: 8px;
				}
			}
		}

		.pop {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;

			.win {
				width: 325px;
				height: 350px;

				p {
					text-align: right;
					padding-bottom: 10px;

					i {
						display: inline-block;
						width: 31px;
						height: 31px;
						background: url('../assets/close.png') no-repeat;
						background-size: 31px 31px;
					}
				}

				.box {
					width: 100%;
					height: 310px;
					background: #F3F3F3;
					border-radius: 7px;
					padding: 30px 15px;
					box-sizing: border-box;

					.submit {
						margin: 30px 25px 0 25px;
						width: 245px;
						height: 44px;
						border-radius: 22px;
						color: #fff;
						font-size: 18px;
						font-weight: bolder;
						background: linear-gradient(to right, #FF9A4F, #FF7509);
					}

					h1 {
						font-size: 18px;
						color: #333333;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}
				}
			}
		}
	}
</style>
